"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ItemElement = _interopRequireDefault(require("../ItemElement"));

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Service = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Service, _React$Component);

  var _super = _createSuper(Service);

  function Service() {
    (0, _classCallCheck2["default"])(this, Service);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Service, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          as = _this$props.as,
          title = _this$props.title,
          price = _this$props.price,
          description = _this$props.description,
          charLimit = _this$props.charLimit,
          image = _this$props.image,
          cardInlinePhoto = _this$props.cardInlinePhoto,
          imageCircular = _this$props.imageCircular,
          imageSize = _this$props.imageSize,
          itemButtonFloat = _this$props.itemButtonFloat,
          itemCenterContent = _this$props.itemCenterContent,
          link = _this$props.link,
          linkAs = _this$props.linkAs,
          verticalItemAlign = _this$props.verticalItemAlign;
      return /*#__PURE__*/_react["default"].createElement(_ItemElement["default"], {
        as: as,
        header: title,
        subheader: price,
        content: description,
        charLimit: charLimit,
        image: image,
        cardInlinePhoto: cardInlinePhoto,
        imageCircular: imageCircular,
        imageSize: imageSize,
        itemButtonFloat: itemButtonFloat,
        itemCenterContent: itemCenterContent,
        link: link,
        linkAs: linkAs,
        verticalItemAlign: verticalItemAlign
      });
    }
  }]);
  return Service;
}(_react["default"].Component);

exports["default"] = Service;
Service.propTypes = {
  title: _propTypes["default"].string.isRequired,
  as: _propTypes["default"].oneOf(['verticalItem', 'horizontalItem', 'card']),
  cardInlinePhoto: _propTypes["default"].oneOf(['left', false]),
  charLimit: _propTypes["default"].number,
  description: _propTypes["default"].string,
  image: _propTypes["default"].string,
  imageCircular: _propTypes["default"].bool,
  imageSize: _propTypes["default"].string,
  itemButtonFloat: _propTypes["default"].oneOf(['left', 'right']),
  itemCenterContent: _propTypes["default"].bool,
  link: _propTypes["default"].string,
  linkAs: _propTypes["default"].oneOf(['header', 'none']),
  price: _propTypes["default"].string,
  verticalItemAlign: _propTypes["default"].oneOf(['left', 'right', 'center'])
};
Service.defaultProps = {
  as: 'horizontalItem',
  cardInlinePhoto: false,
  charLimit: 200,
  description: '',
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  price: '',
  verticalItemAlign: 'center'
};